import { TimeMap, Time } from 'roadie-ui'
import { WeeklyStatement, SeattleData, SeattleDay } from 'types/seattle'

type SeattlePSSTResponse = {
  psst_days: PSSTDay[]
  seattle_work_days: SeattleWorkDay[]
  days_worked?: WorkDay[]
  total_pay?: number
  average_daily_compensation?: number
}

type PSSTDay = {
  id: number
  /**
   * `earned` - Day is accrued for spending
   *
   * `requested` - Day has been requested for payout
   *
   * `exercised` - Day has been paid out
   */
  state: 'earned' | 'requested' | 'exercised'
  date_requested_off?: string
}

type SeattleWorkDay = {
  start_at: string
}

type WorkDay = string

export function psstResponseToSeattleData(
  psstResponse: SeattlePSSTResponse,
  weeklyStatements: WeeklyStatement[]
): SeattleData {
  const psstDays = psstResponse.psst_days.filter((psstDay) => psstDay.state === 'earned')
  const earnings = psstResponse.total_pay ?? 0
  const earningsPerDay = (psstResponse.average_daily_compensation ?? 0) / 100
  const daysWorked = psstResponse.days_worked ?? []
  const seattleDays = new TimeMap<SeattleDay>()

  psstResponse.psst_days
    .filter((psstDay) => psstDay.state !== 'earned')
    .forEach((psstDay) => {
      if (!psstDay.date_requested_off) {
        return
      }

      const time = Time.fromDate(new Date(psstDay.date_requested_off))

      seattleDays.set(time, {
        ...(seattleDays.get(time) ?? {}),
        psstUsed: true,
      })
    })
  psstResponse.seattle_work_days.forEach((seattleWorkDay) => {
    const time = Time.fromDate(new Date(seattleWorkDay.start_at))

    seattleDays.set(time, {
      ...(seattleDays.get(time) ?? {}),
      seattleGigCompleted: true,
    })
  })

  return {
    earnings,
    earningsPerDay,
    daysWorked: daysWorked.length,
    psstDays,
    seattleDays,
    weeklyStatements,
  }
}
